import React from 'react';
import { useTranslation } from 'react-i18next';
import { IntegrationPageContentProps } from '../IntegrationPage';
import { useSettings } from 'services/settings/SettingsContext';
import { convertUTCToLocalDateTimeString } from 'internationalization/timezoneConversions';

// Shows how the mkg integration works once it is activated
const MkgIntegrationPageContent: React.FC<IntegrationPageContentProps> = ({ response }) => {
    const { t } = useTranslation();
    const { userLocale, userTimezone } = useSettings();

    // Render nothing while the integration is not activated yet
    if (!response?.is_active) {
        return null;
    }

    return (
        <>
            {/* Integration information */}
            <div className='integration-details'>
                <div className='header'>
                    {t('integrations.general.info_title')}:
                </div>
                <p>{t('integrations.general.mkg.info_description')}</p>
            </div>

            {/* Activation date */}
            {response?.activated_at && (
                <div className='integration-details'>
                    <div className='header'>
                        {t('integrations.mkg.activated_at_label')}
                    </div>
                    <p>
                        {new Date(convertUTCToLocalDateTimeString(response.activated_at, userLocale, userTimezone)).toLocaleString()}
                    </p>
                </div>
            )}
        </>
    );
};

export default MkgIntegrationPageContent;
